import React from 'react';
import { BrushIcon } from 'lucide-react';
import { CreativeDirectoryPage, CreativeArtist } from '../../components/creative/CreativeDirectoryPage';
const artists: CreativeArtist[] = [{
  id: '1',
  name: 'Alex Rivera',
  title: 'Character Artist & Illustrator',
  specialties: ['Fantasy Characters', 'Portraits', 'Digital Art'],
  rating: 4.9,
  reviewCount: 142,
  imageUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$300-800'
}, {
  id: '2',
  name: 'Jordan Lee',
  title: 'Digital Character Designer',
  specialties: ['Sci-Fi', 'Comic Style', 'Concept Art'],
  rating: 4.8,
  reviewCount: 78,
  imageUrl: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$250-600'
}];
const CharacterArtists = () => <CreativeDirectoryPage title="Character Artists" subtitle="Find talented artists to bring your characters to life through stunning illustrations and artwork" icon={<BrushIcon className="h-8 w-8" data-id="element-9280" data-mp="2278xd39jhqo3" />} profileBasePath="/creative/character-artists" artists={artists} data-id="element-9279" data-mp="13znt3tep6nsn" />;
export default CharacterArtists;